import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { UserFilterPipe, RoleFilterPipe, CapabilityFilterPipe, SortPipe, ItemFilterPipe } from './utils';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import {NgClickOutsideDirective} from 'ng-click-outside2';
import { MultiSelectCheckboxComponent } from './multi-select-checkbox/multi-select-checkbox.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { BarGraphComponent } from './bar-graph/bar-graph.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TypeaheadComponent } from './typeahead/typeahead.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SearchBarComponent } from './search-bar/search-bar.component';

@NgModule({
	imports: [CommonModule, ReactiveFormsModule, NgClickOutsideDirective, FormsModule],
	providers: [],
	declarations: [
		LoaderComponent,
		ConfirmationModalComponent,
		UserFilterPipe,
		MultiSelectComponent,
		RoleFilterPipe,
		ItemFilterPipe,
		CapabilityFilterPipe,
		MultiSelectCheckboxComponent,
		DatePickerComponent,
		BarGraphComponent,
		SpinnerComponent,
		TypeaheadComponent,
		SortPipe,
		SearchBarComponent,
	],
	exports: [
		LoaderComponent,
		ConfirmationModalComponent,
		UserFilterPipe,
		MultiSelectComponent,
		RoleFilterPipe,
		ItemFilterPipe,
		CapabilityFilterPipe,
		SortPipe,
		NgClickOutsideDirective,
		MultiSelectCheckboxComponent,
		DatePickerComponent,
		BarGraphComponent,
		SpinnerComponent,
		TypeaheadComponent,
		SearchBarComponent,
	],
})
export class SharedModule {}
